import styled from 'styled-components';

import Headline from '@klv/atoms/headline';
import Typography from '@klv/atoms/typography';
import Button from '@klv/atoms/button';

export const CalloutText = styled(Typography)`
  background-color: ${({ theme }) => theme.colors.sage};
  display: block;
  padding: 1.2rem 0;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  width: 100%;
`;

export const CardContents = styled.div`
  flex-grow: 1;
  padding: 4rem 2rem 0;
  position: relative;
`;

export const PlanName = styled(Typography)`
  margin-bottom: 0.8rem;
`;

export const PriceEyebrow = styled(Typography)`
  font-size: 1.6rem;
  line-height: 1.5;
  margin-bottom: 0.2rem;
`;

export const PriceWrapper = styled.div`
  display: flex;
  column-gap: 0.8rem;
  align-items: baseline;
  margin-bottom: 2.4rem;
`;

export const Amount = styled(Headline)`
  font-weight: 500;
`;

export const TimePeriod = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.pricing.timePeriod};
  `}
`;

export const Copy = styled(Typography)`
  margin-bottom: 2.4rem;

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      min-height: 8.1rem;
    }
  `}
`;

export const CTA = styled(Button)``;

export const DemoButton = styled(Button)``;

export const ButtonContainer = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
`;

export const Divider = styled.div`
  height: 0.1rem;
  width: 100%;
  margin: 2.4rem 0;

  ${({ theme }) => `
    background-color: ${theme.pricing.cardBorder};
  `}
`;

export const PlanChildren = styled.div``;

export const PlanFeatures = styled.ul`
  list-style: none;
  padding: 0;
`;

export const Feature = styled.li`
  margin-bottom: 1.6rem;
`;

export const Text = styled(Typography)<{ $bold?: boolean; }>`
  line-height: 1.5;
  font-size: 1.6rem;

  &&& {
    ${({ $bold }) => `
      ${$bold ? 'font-weight: 500;' : ''}
    `}
  }
`;

export const PlanDetails = styled.div`
  padding: 2rem;

  ${({ theme }) => `
    background-color: ${theme.pricing.accent};
  `}
`;

export const StyledPlanCard = styled.div<{ hasCalloutText: boolean; }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 1.2rem;
  overflow: hidden;
  margin: 0.2rem;

  ${({ hasCalloutText, theme }) => `
    background-color: ${theme.pricing.cardBackground};
    border: 1px solid ${theme.pricing.cardBorder};

    ${theme.screenSize.s1024.mediaQuery} {
      &:hover {
        border-color: ${theme.pricing.accent};
        border-width: 3px;
        box-shadow: 0 4px 8px rgb(0 0 0 / 8%);
        margin: 0;
      }
    }

    ${CardContents} {
      ${hasCalloutText ? `
        padding-top: 6rem;
      ` : ''}
    }
  `}
`;
